import { render, staticRenderFns } from "./t.vue?vue&type=template&id=3808799c&"
import script from "./t.vue?vue&type=script&lang=js&"
export * from "./t.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "t.vue"
export default component.exports